firstSegmentPeriod